import { thumbHashToDataURL } from "thumbhash";

/**
 * Converts a base64 ThumbHash into a Uint8Array.
 */
export function base64ToThumbHash(base64: string): Uint8Array {
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
}

/**
 * Converts a base64 ThumbHash into a PNG data URL.
 */
export function thumbHashBase64ToDataURL(base64: string): string {
  return thumbHashToDataURL(base64ToThumbHash(base64));
}
